import { Dataset } from '../types/types';

export const getDataKey = (dataset: Dataset | undefined) =>
  dataset?.idItem || '_id';
